/** @jsx jsx */
import { jsx, Card, Heading, Text, Link, Flex, Image } from "theme-ui"
import { graphql } from "gatsby"
import moment from "moment"
import PageTitle from "../components/page_title"
import Layout from "../components/layout"
import PropTypes from "prop-types"
import ReactMarkdown from 'react-markdown';

export const query = graphql`
  query opportunitiesPageQuery {
    allOpportunitiesJson(sort: { fields: date, order: ASC }) {
      distinct(field: title)
      nodes {
        title
        url
        org
        date
        description
        id
        image
      }
    }
    allImageSharp(
      filter: { fluid: { originalName: { eq: "opportunity_placholder.png" } } }
    ) {
      nodes {
        fluid {
          src
        }
      }
    }
  }
`

export default function OpportunitiesPage({ data }) {
  const allOpportunities = data.allOpportunitiesJson.nodes.filter(
    (opportunity) => moment(opportunity.date).diff(moment()) > 0
  )
  const closestOpportunity = allOpportunities[0]
  const placeholderImage = data.allImageSharp.nodes[0].fluid.src

  return (
    <Layout>
      <PageTitle>Opportunities</PageTitle>
      {allOpportunities.length === 0 ? (
        <Heading as="h3">No opportunities at the moment!</Heading>
      ) : (
        <div>
          <Heading sx={{ mb: 3 }}>Closest Deadline:</Heading>
          <OpportunityCard
            isClosest
            opportunity={closestOpportunity}
            placeholderImage={placeholderImage}
          />
          <Heading sx={{ mb: 3 }}>Upcoming:</Heading>
          {allOpportunities.length === 1 ? (
            <Heading as="h3">No other opportunities at the moment!</Heading>
          ) : (
            allOpportunities
              .slice(1)
              .map((opportunity) => (
                <OpportunityCard
                  key={opportunity.id}
                  opportunity={opportunity}
                />
              ))
          )}
        </div>
      )}
    </Layout>
  )
}
OpportunitiesPage.propTypes = {
  data: PropTypes.object.isRequired,
}

function OpportunityCard({ isClosest, opportunity, placeholderImage }) {
  return (
    <Card
      key={opportunity.id}
      sx={{
        mb: isClosest ? 5 : 3,
        boxShadow: isClosest ? "large" : "small",
      }}
    >
      {(isClosest && opportunity.image) ? (
        <Image
        src={opportunity.image}
        sx={{
          borderRadius: "10px",
          opacity: "90%",
          maxHeight: "300px",
          objectFit: "cover",
          width: "100%",
        }}
      />
      ) : null}
      <Heading variant="cardTitle" sx={{ mt: isClosest ? 3 : "inherit" }}>
        <Link href={opportunity.url} target="_blank">{opportunity.title}</Link>
      </Heading>
      <Flex
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Heading variant="subtitle">{opportunity.org}</Heading>
        <Text sx={{ mr: 2, fontWeight: 700 }}>
          Due {moment(opportunity.date).format("MM/DD/YYYY")}
        </Text>
      </Flex>
      <Text><ReactMarkdown components={{a: Link}}>{opportunity.description}</ReactMarkdown></Text>
    </Card>
  )
}
OpportunityCard.propTypes = {
  isClosest: PropTypes.bool,
  opportunity: PropTypes.object.isRequired,
  placeholderImage: PropTypes.string,
}
